import axios, { AxiosInstance, AxiosResponse } from "axios";
import { WordCloudResponse } from "../../../@Types/DRO/ChurnApiResponse/WordCloudResponse";



export class WordCloudApi {
  public static api = new WordCloudApi();
  private instance: AxiosInstance;

  constructor() {
    this.instance = axios.create({
      baseURL: process.env.REACT_APP_CHURN_BASE_URL,
      headers: {
        "Content-Type": "application/json",
      },
    });
  }

  getToken() {
   return localStorage.getItem("token");
  }
  async getWordCloudData(): Promise<WordCloudResponse> {
    try {
      const response: AxiosResponse<WordCloudResponse> =
        await this.instance.get("/word-cloud", {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching churn percent graph data", error);
      throw error;
    }
  }
 
}
